import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=4d481d25&scoped=true&"
import script from "./Sliders.vue?vue&type=script&lang=js&"
export * from "./Sliders.vue?vue&type=script&lang=js&"
import style0 from "./Sliders.vue?vue&type=style&index=0&id=4d481d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d481d25",
  null
  
)

export default component.exports